import { resolveBrand } from "./brandStyles";

/**
 * Disegna la cornice del foglio in base allo stile scelto.
 * - none: nessuna cornice
 * - double: due filetti sottili in colore accent
 * - thick: cornice spessa singola in colore accent
 * - block: cornice spessa in colore primary (street food)
 */
export function drawFrame(doc, W, H, margin, style, rgb) {
    const { primary, accent } = rgb;
    const inset = 5;
    switch (style.frame) {
        case "double":
            doc.setDrawColor(...accent);
            doc.setLineWidth(0.4);
            doc.rect(inset, inset, W - inset * 2, H - inset * 2);
            doc.rect(inset + 1.6, inset + 1.6, W - (inset + 1.6) * 2, H - (inset + 1.6) * 2);
            break;
        case "thick":
            doc.setDrawColor(...accent);
            doc.setLineWidth(1.6);
            doc.rect(inset, inset, W - inset * 2, H - inset * 2);
            break;
        case "block":
            // bordo navy + filetto interno accent
            doc.setDrawColor(...primary);
            doc.setLineWidth(2.4);
            doc.rect(inset, inset, W - inset * 2, H - inset * 2);
            doc.setDrawColor(...accent);
            doc.setLineWidth(0.4);
            doc.rect(inset + 2.6, inset + 2.6, W - (inset + 2.6) * 2, H - (inset + 2.6) * 2);
            break;
        case "none":
        default:
            // niente cornice (modern)
            break;
    }
}

/**
 * Disegna il logo mantenendo le proporzioni originali del file,
 * centrato in (cx, topY), con un'altezza massima e una larghezza massima.
 * Ritorna l'altezza effettivamente usata.
 */
export function drawLogoPreserved(doc, dataUrl, cx, topY, maxW, maxH) {
    if (!dataUrl) return 0;
    try {
        const props = doc.getImageProperties(dataUrl);
        const ratio = props.width / props.height;
        let w = maxW;
        let h = w / ratio;
        if (h > maxH) {
            h = maxH;
            w = h * ratio;
        }
        const x = cx - w / 2;
        doc.addImage(dataUrl, props.fileType || "PNG", x, topY, w, h, undefined, "FAST");
        return h;
    } catch {
        return 0;
    }
}

/**
 * Trasforma il testo secondo le regole dello stile:
 * - upper: TUTTO MAIUSCOLO
 * - smallcaps: simula maiuscoletto rendendo la prima lettera maiuscola e il resto in caratteri più piccoli
 *   (jsPDF non supporta veri small-caps → applichiamo solo UPPER su testi corti per Vintage)
 * - normal: passthrough
 */
export function caseTransform(text, mode) {
    if (!text) return "";
    if (mode === "upper") return text.toUpperCase();
    if (mode === "smallcaps") return text.toUpperCase(); // jsPDF fallback
    return text;
}

/** Util: ritorna oggetto brand già risolto da chiamare nei generatori PDF. */
export function brand(opts) {
    return resolveBrand(opts);
}

/**
 * Formato Euro italiano: 12,50 €
 */
export function priceLabel(price) {
    if (price == null || price === "" || isNaN(Number(price))) return "";
    const n = Number(price);
    if (n <= 0) return "";
    return `${n.toFixed(2).replace(".", ",")} €`;
}

/**
 * Imposta colore di un Font ad uso "muted/secondario".
 */
export function applyMuted(doc, rgb) {
    doc.setTextColor(...rgb.muted);
}
